package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.{MessageType, PowerStatusData, SequenceStatus, SetChatVolumeData, SetChatVolumeMessage, SetSubjectAVData, SetSubjectAVMessage}
import com.neurobs.ccabserver.administrator.view.VideoChatView
import com.neurobs.js.ccab.CCABChatSession
import com.neurobs.util.CommunicationState
import io.circe.generic.auto._

class VideoChatController (view: VideoChatView, session: CCABChatSession, chatDuringPause: Boolean) {
	import com.neurobs.ccab.MessageData._

	private def setSubjectAV(): Unit = {
		val data = SetSubjectAVData(
			video = view.subjectVideoCheckbox.checked,
			audio = view.subjectAudioCheckbox.checked
		)
		session.send(SetSubjectAVMessage(data = data))
	}

	view.commStatus.volumeUpButton.setHandler { () =>
		session.send(SetChatVolumeMessage(data = SetChatVolumeData(change = Some(0.03))))
	}
	view.commStatus.volumeDownButton.setHandler { () =>
		session.send(SetChatVolumeMessage(data = SetChatVolumeData(change = Some(-0.03))))
	}

	private def startChat(audioOnly: Boolean)(): Unit = {
		if (!session.isPublishingAV) {
			//sender.send(MessageType.QuitTest)
			session.setPublishing(audio = true, video = !audioOnly)
			view.subjectVideoCheckbox.setChecked(true)
			view.subjectAudioCheckbox.setChecked(true)
			setSubjectAV()
			session.send(MessageType.ClearHelpRequested)
		}
	}

	private def endChat(): Unit = {
		if (session.isPublishingAV) {
			session.setPublishing(audio = false, video = false)
			view.subjectAudioCheckbox.setChecked(false)
			setSubjectAV()
		}
	}

	def update(comState: CommunicationState, status: Option[SequenceStatus.Value], localPresentation: Option[Boolean]): Unit = {
		val chatting = comState.localAudio || comState.localVideo
		view.subjectVideoCheckbox.setChecked(comState.remoteVideo)
		view.setSubjectVideoVisible(!chatting)

		view.subjectAudioCheckbox.setChecked(comState.remoteAudio)
		view.setSubjectAudioVisible(!chatting)
		view.setSubjectVolumeVisible(comState.remoteAudio)

		val (audioOnly, chatEnabled) = if (chatting) (false, true) else status.getOrElse(SequenceStatus.Finished) match {
			case SequenceStatus.Finished | SequenceStatus.Stopped => (false, true)
			case SequenceStatus.Running => (false, false)
			case SequenceStatus.Paused => (localPresentation.getOrElse(true), chatDuringPause)
		}
		view.setChatButtonState(visible = !chatting, audioOnly = audioOnly, enabled = chatEnabled)
		view.chatButton.setHandler(startChat(audioOnly))

		view.setEndChatButtonVisible(chatting)

		view.setChatIndicatorVisible(chatting)
	}

	def updatePowerStatus(data: PowerStatusData): Unit = view.powerStatus.set(data)

	def upsize(): Unit = {
		view.remoteVideo.adjustPercent(difference = 0.1)
	}
	def downsize(): Unit = {
		view.remoteVideo.adjustPercent(difference = -0.1)
	}

	def setExaminerList(examiners: Seq[String]): Unit = view.examinerChat.setExaminerList(examiners)

	def addExaminerMessage(message: String, user: String): Unit = view.examinerChat.addMessage(message, user)

	view.subjectAudioCheckbox.setChangeHandler(setSubjectAV)
	view.setSubjectVolumeChangeHandler(v => session.setPlaybackVolume(v))
	view.subjectVideoCheckbox.setChangeHandler(setSubjectAV)
	view.endChatButton.setHandler(endChat)
	view.upsizeButton.setHandler(upsize)
	view.downsizeButton.setHandler(downsize)
	view.examinerChat.onSubmitMessage = (message) => {
		session.sendAdminChat(message)
	}
	update(CommunicationState(false, false, false), None, None)
}
